import React from 'react'

export default function Logout({
  width = 41,
  height = 41,
  color = "#999999"
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 1">
        <g id="Group 3">
          <path id="Ellipse 5" d="M26.8676 14.7018C27.296 14.2733 27.9961 14.27 28.375 14.7427C29.3758 15.9913 30.0659 17.4663 30.3801 19.0462C30.766 20.986 30.5679 22.9966 29.8111 24.8239C29.0542 26.6512 27.7725 28.2129 26.128 29.3118C24.4835 30.4106 22.5501 30.9971 20.5723 30.9971C18.5945 30.9971 16.6611 30.4106 15.0166 29.3118C13.3721 28.213 12.0904 26.6512 11.3335 24.8239C10.5766 22.9967 10.3786 20.986 10.7644 19.0462C11.0787 17.4663 11.7687 15.9913 12.7695 14.7427C13.1484 14.27 13.8485 14.2733 14.2769 14.7018C14.7054 15.1302 14.6981 15.8209 14.3339 16.3052C13.6323 17.238 13.146 18.3203 12.9164 19.4742C12.6152 20.9884 12.7698 22.5579 13.3606 23.9842C13.9514 25.4106 14.9519 26.6297 16.2356 27.4874C17.5193 28.3451 19.0284 28.8029 20.5723 28.8029C22.1161 28.8029 23.6253 28.3451 24.909 27.4874C26.1926 26.6297 27.1931 25.4106 27.7839 23.9842C28.3747 22.5579 28.5293 20.9884 28.2281 19.4742C27.9986 18.3203 27.5122 17.238 26.8106 16.3052C26.4464 15.8209 26.4391 15.1302 26.8676 14.7018Z" fill={color} />
          <path id="Vector 1" d="M20.5723 12.9824V20.4683" stroke={color} stroke-width="2" stroke-linecap="round" />
        </g>
      </g>
    </svg>

  )
}
